const SkeletonRestaurantTemplate = (count) => {
  let template = ''

  for (let i = 0; i < count; i += 1) {
    template += `
      <div class="restaurant-item">
          <img class="lazyload restaurant-item__image" width="100%" height="350px" data-src="https://via.placeholder.com/620x350" alt="skeleton">
          <div class="restaurant-item__name" style="width: 150px; height: 40px"></div>
          <div class="restaurant-item__rating" style="width: 150px; height: 40px"></div>
      </div>
    `
  }

  return template
}

export default SkeletonRestaurantTemplate
